import React, { Component } from "react";
import { getEvents, updateCurrentPage  } from "../store/events";
import { getCurrentUser } from "../store/auth";
import { connect } from "react-redux";
// import Image from "react-image-resizer";
// import Image from "react-bootstrap/Image";
import EventCard from "./eventCard";
import { Container, Row, Col } from "reactstrap";
import { sortList } from "./common/helpers";
import Events, {mapStateToProps, mapDispatchToProps} from "./events";

class MyEvents extends Events {
  
  async componentDidMount() {
    if (this.getPrevPath() !== "/imagesFull"){
      try {
        
        await this.props.getEvents();
        await this.props.getCurrentUser();
      
      } catch (err) {
        console.log(err.message);
        return (window.location = "/");
      }
    }

    const myEvents = this.props.events.filter(event => {
        return event.uid === this.props.currentUser._id && !event.adminGen;
    });

    let comingEvents = myEvents.filter((event) => {
      return (
        new Date(event.dateTime) >= new Date().setDate(new Date().getDate() - 2)
      );
    });

    let pastEvents = myEvents.filter(
      (event) => !comingEvents.includes(event)
    );

    comingEvents = sortList(comingEvents, "dateTime");
    pastEvents = sortList(pastEvents, "dateTime", true);

    const comingEventsActive = comingEvents.filter(event=>event.active===true); 
    const pastEventsActive = pastEvents.filter(event=>event.active===true); 
    const comingEventsInactive = comingEvents.filter(event=>event.active===false); 
    const pastEventsInactive = pastEvents.filter(event=>event.active===false);

    this.setState({  
      events:[...comingEventsActive, ...pastEventsActive, ...comingEventsInactive, ...pastEventsInactive],
      updateCurrentPage:this.props.updateCurrentPage, 
      currentPage:this.props.currentPage  
    });
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(MyEvents);
